// extracted by mini-css-extract-plugin
export default {"qrCode":"index_qrCode_eHNEg","closeBtn":"index_closeBtn_ZRv-j"};